import React, { useEffect, useState } from "react";
import { deleteAssembliestNote, getNotesAssembliesList, updateAssembliesNote } from "../../services/AssembliesService";
import SkeletonContainer, { getSkeletonHeight } from "../../loaders/SekletonContainer";
import moment from "moment";
import Swal from "sweetalert2";
import UpdateAssembliesNote from "./UpdateAssembliesNote";
import { ContainerWrapper } from "../common/GlobalElements/Wrappers";
import { BodySmall,  Heading4, LabelText } from "../common/GlobalElements/Typography";
import { tokens } from "../../public/tokens";
import { StandardButton } from "../common/GlobalElements/StandardButton";

export default function LessonNotesList(props) {
  const {timestamp,setPlayerSeek,editNoteId,setEditNoteId,setEditNote,editNote,minimized, refresh, setRefresh,closeEditNotes,setVideoPlay}=props
  const [notesList, setNotesList] = useState([]);
  const [loading, setLoading] = useState(true);



  useEffect(() => {
    let mounted = true;

    getNotesAssembliesList({ assemblies_items_id: props.lessonItemId,intake_id:props.subjectId })
      .then((res) => {
        if (mounted) {
          setNotesList(res.data?.data?.data);
          setLoading(false);
        }
      })
      .catch((error) => {
        console.error("Error fetching notes:", error);
        setLoading(false);
      });

    return () => {
      mounted = false;
    };
  }, [props.lessonItemId,refresh]);

  const handleDeleteNote = (item_id) => {
    Swal.fire({
      title: "Are you sure?",
      text: "You won't be able to revert this!",
      icon: "warning",
      showCancelButton: true,
      confirmButtonColor: tokens.colors.brand.blue[500],
      cancelButtonColor: tokens.colors.brand.red[500],
      confirmButtonText: "Yes, delete it!",
    }).then((result) => {
      if (result.isConfirmed) {
        deleteAssembliestNote({ id: item_id })
          .then((res) => {
            Swal.fire({
              icon: "success",
              title: "Deleted!",
              text: "Note has been deleted successfully.",
              timer: 3000,
              onOpen: function () {
                Swal.showLoading();
              },
            })
            setRefresh(Date.now())
          })
          .catch((error) => {
            console.log(error)
            Swal.fire({
              icon: "error",
              title: "Error!",
              text: error?.message,
              timer: 3000,
              onOpen: function () {
                Swal.showLoading();
              },
            })
      });
      }
    });
  };

  function HandleEditNote(note_id){
    setEditNoteId(note_id)
    setEditNote(true)    
  }

  const formatTimestamp = (seconds) => {
    const duration = moment.duration(seconds, 'seconds');
    const hours = duration.hours();
    const minutes = duration.minutes();
    const formattedMinutes = minutes < 10 ? `0${minutes}` : minutes;
    const formattedSeconds = duration.seconds() < 10 ? `0${duration.seconds()}` : duration.seconds();
    
    return hours > 0 ? `${hours}:${formattedMinutes}:${formattedSeconds}` : `${formattedMinutes}:${formattedSeconds}`;
  };

  const handleVideoJump=(time)=>{
    setPlayerSeek(time)
    props.resumeFromTime(time)
  }

  return (
    <>
      {loading && <SkeletonContainer height={getSkeletonHeight(10)} />}
      {notesList?.length > 0 && <ContainerWrapper>
        {((!loading && !editNote) || minimized) &&
          <>
            <Heading4 className="m-0" title="Saved Notes">Saved Notes</Heading4>
            <div className="notes-card-wrap">
              {notesList.map((note, index) => (
                <div key={index} className={`notes-card ${notesList.length > 1 ? "notes__card__box" : null}`}>
                  <div className="notes-clip">
                    <BodySmall fontWeight={tokens.typography.fontWeights.semibold} className="text-theme-topbar mb-1" onClick={()=>handleVideoJump(note?.video_end_duration)} title={`Play Video Clip ${formatTimestamp(note?.video_end_duration )} - ${formatTimestamp(note?.video_end_duration)}`}>
                      <i className="fal fa-play mr-1" />
                      <span>
                        Play Video Clip {formatTimestamp(note?.video_start_duration)} - {formatTimestamp(note?.video_end_duration)}
                      </span>
                    </BodySmall>
                    <div className="video-clip-created">
                      <LabelText as="p"  title={`Created ${moment(note?.created_at).format("h:mm, DD MMMM YYYY")}`}>Created {moment(note?.created_at).format("h:mm, DD MMMM YYYY")}</LabelText>
                      <LabelText as="p" title={`Last Modified ${moment(note?.updated_at).format("h:mm, DD MMMM YYYY")}`}>Last Modified {moment(note?.updated_at).format("h:mm, DD MMMM YYYY")}</LabelText>
                    </div>    
                    <BodySmall className="text-secondary" title={`${note?.notes_content}`}>
                      {note?.notes_content}
                    </BodySmall>
                    <div className="btn-group d-flex gap-2">
                      <StandardButton variant="theme" textOnly={true} className="btn-edit-notes" type="button" onClick={() => HandleEditNote(note.id)} title="Edit Note">
                        <i className="fal fa-edit" />
                        <span>Edit Note</span>
                      </StandardButton>
                      <StandardButton textOnly={true} variant="danger" className="btn-delete-notes" type="button" onClick={() => handleDeleteNote(note.id)} title="Delete Note">
                        <i className="fal fa-times" />
                        <span>Delete Note</span>
                      </StandardButton>
                    </div>
                  </div>
                </div>
              ))}
            </div>
          </>
        }
        {!loading && !minimized && editNote && <UpdateAssembliesNote note_id={editNoteId} setRefresh={setRefresh} subjectId={props.subjectId} closeEditNotes={setEditNote} />}
      </ContainerWrapper>}
    </>
  );
}
